@let data = summary();
<div class="flex flex-col gap-6">
  <section class="flex flex-col gap-2">
    <p class="text-sm font-bold text-content-default">
      {{ 'ANALYSIS.DETAILS.SECTION_GENERAL' | translate }}
    </p>
    <div class="rounded-lg bg-surface-neutral-subdued p-4">
      <pm-definition-list [items]="data.general">
        <ng-template pmDefinitionListValue let-value>{{ value }}</ng-template>
      </pm-definition-list>
    </div>
  </section>

  <section class="flex flex-col gap-2">
    <p class="text-sm font-bold text-content-default">
      {{ 'ANALYSIS.DETAILS.SECTION_TIMESERIES' | translate }}
    </p>
    <div class="rounded-lg bg-surface-neutral-subdued p-4">
      <pm-definition-list [items]="data.timeseries">
        <ng-template pmDefinitionListValue let-value>{{ value }}</ng-template>
      </pm-definition-list>
    </div>
    @if (data.missingValueNoteKey; as noteKey) {
      <p class="text-xs text-content-subdued">{{ noteKey | translate }}</p>
    }
  </section>

  <section class="flex flex-col gap-2">
    <p class="text-sm font-bold text-content-default">
      {{ 'ANALYSIS.DETAILS.SECTION_HIERARCHY' | translate }}
    </p>
    <div class="rounded-lg bg-surface-neutral-subdued p-4">
      <pm-definition-list [items]="data.hierarchy">
        <ng-template pmDefinitionListValue let-value>{{ value }}</ng-template>
      </pm-definition-list>
    </div>
  </section>

  <section class="flex flex-col gap-2">
    <p class="text-sm font-bold text-content-default">
      {{ 'ANALYSIS.DETAILS.SECTION_MEASURES' | translate }}
    </p>
    <div class="flex flex-col gap-3 rounded-lg bg-surface-neutral-subdued p-4">
      <pm-definition-list [items]="data.measures">
        <ng-template pmDefinitionListValue let-value>{{ value }}</ng-template>
      </pm-definition-list>
      @if (data.consensusEvaluated) {
        <p class="text-xs text-content-subdued">
          {{ 'ANALYSIS.DETAILS.CONSENSUS_LEVEL_NOTE' | translate }}
        </p>
      }
    </div>
  </section>
</div>
